(function(){
  var _ready = false;
  function onReady(fn){
    if (_ready) return fn();
    if (document.readyState === 'complete' || document.readyState === 'interactive') { _ready = true; return fn(); }
    document.addEventListener('DOMContentLoaded', function(){ _ready = true; fn(); });
  }
  function noopChunk(arr){
    var out = [];
    for (var i = 0; i < (arr||[]).length; i++) { out.push(arr[i]); }
    return out;
  }
  function bindSections(){
    var roots = document.querySelectorAll('[data-section-id]');
    for (var i = 0; i < roots.length; i++) {
      var el = roots[i];
      if (el.dataset.bound === '1') continue;
      el.dataset.bound = '1';
    }
  }
  window.__themeBoot = window.__themeBoot || { ready: onReady, chunk: noopChunk };
  onReady(bindSections);
})();
